import React from "react"
import { styled, Theme } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import withPremiumPermission from "components/HOCs/withPremiumPermission"

type BottomSheetMenuItemProps = {
  premiumPermissionKey?: string;
  icon: React.ReactNode;
  label: string | React.ReactNode;
  color?: string | undefined;
  onClick: (event: React.MouseEvent) => void;
}

export default function BottomSheetMenuItem(props: BottomSheetMenuItemProps) {
  const { premiumPermissionKey, icon, label, color, onClick } = props

  return (
    <ContainerWithPremiumPermission
      feature={premiumPermissionKey || ""}
      color={color}
      onClick={onClick}
    >
      {icon}
      {label}
    </ContainerWithPremiumPermission>
  )
}

type ContainerProps = {
  theme?: Theme;
  color?: string;
}

const Container = styled(Stack)(({ theme, color }: ContainerProps) => ({
  flexDirection: "row",
  gap: "8px",
  alignItems: "center",
  color: color || theme?.palette.gray["13"],
  fontSize: "1.4rem",
  fontWeight: 400,

  "& svg": {
    width: "24px",
    height: "24px",
    stroke: `${theme?.palette.gray["13"]} !important`
  }
}))

const ContainerWithPremiumPermission = withPremiumPermission(Container)
